const component = {

	/**
	 * Init module
     * 
     * @return {boolean|undefined}
	 */
    init: () => {

        window.theme = window.theme || {};
    	window.theme.quantity_selector = component; 
        component.load();
	},

	load: () => {

        component.target = document.querySelectorAll('[data-quantity-selector]');

        if (!component.target)
            return false;

        component.target.forEach(element => {

            if(!element.classList.contains('active')){

                let input = element.parentElement.querySelector('input');

                if(parseInt(input.value) == 1) {
                    element.querySelector('.icon-trash').classList.remove('hidden');
                    element.querySelector('.icon-less').classList.add('hidden');
                } else {
                    element.querySelector('.icon-trash').classList.add('hidden');
                    element.querySelector('.icon-less').classList.remove('hidden');
                }

                element.querySelector('[data-quantity-selector-minus]').addEventListener('click', event => {
                    component.decrease(input, element);
                });

                let vendor = input.dataset.vendor?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

                if(vendor != "inner-circle") {

                    element.querySelector('[data-quantity-selector-plus]').addEventListener('click', event => {
                        component.increase(input, element);
                    });

                }

                element.classList.add('active');

            }

        });
	},

    /**
	 * Decrease input value
     * 
     * @param {input} input A input for the quantity selector.
	 */

    decrease: (input, element) => {

        let value = parseInt(input.value);

        if (value > 0) {

            value--;

            input.value = value;

            if(value == 1) {
                element.querySelector('.icon-trash').classList.remove('hidden');
                element.querySelector('.icon-less').classList.add('hidden');
            }

            let event = new CustomEvent('change', {'detail': input });

            input.dispatchEvent(event);
        }
    },

    /**
	 * Increase input value
     * 
     * @param {input} input A input for the quantity selector.
	 */

    increase: (input, element) => {

        let value = parseInt(input.value);

        value++;

        input.value = value;

        if(value == 2) {
            element.querySelector('.icon-trash').classList.add('hidden');
            element.querySelector('.icon-less').classList.remove('hidden');
        }

        let event = new CustomEvent('change', {'detail': input });
            
        input.dispatchEvent(event);
    }
};

export default component;
